module.exports = __webpack_public_path__ + "static/media/swap.78e67088.svg";